import React, {Component} from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import {Redirect} from 'react-router';
import $ from 'jquery';
import OwlCarousel from 'react-owl-carousel';  
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Buysubscription from './Buysubscription';
import Buyxchange from './Buyxchange';
import Giftxchange from './Giftxchange';
import Modal from "react-bootstrap/Modal";
import AddCharacter from './AddCharacter';
import 'bootstrap/dist/css/bootstrap.min.css';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Profile extends Component{
	constructor(props){
		super(props);

		this.state = {
			showBuySubscription: false,
			showBuyXchange: false,
			showGiftXchange: false,
			showAddCharacterPopup: false,
			characterList: [],
			characterImageList: [],
			gameSlides: null,
			topThreeCharacters: null,
			topThreeCharacterList: [],
			topThreeCharacterImageList: [],
			dataLanguage: dictionaryList['English'],
			username: '',
			userAvatar: null,
			totalPosts: 0,
			totalComments: 0,
			totalCharacters: 0,
			totalAssets: 0,
			maxCount: 1,
			redirect: null,
			searchKeyword: '',
			startKeyword: '',
			currentUserId: 0,
			currentGameId: 0,
			xchangeAmount: 0,
			remaining_days: 0,
			assetNetworth: 0,
			characterNetworth: 0,
			toCurrency: null,
			orgCurrencyList: [],
			gameList: []
		};

		this.initProfileData = this.initProfileData.bind(this);
		this.getAllGameList = this.getAllGameList.bind(this);
		this.getGameList = this.getGameList.bind(this);
		this.getTopThreeCharacters = this.getTopThreeCharacters.bind(this);
		this.setUserName = this.setUserName.bind(this);
		this.getPostCountData = this.getPostCountData.bind(this);
		this.makeGameCharacterList = this.makeGameCharacterList.bind(this);
		this.drawTopThreeCharacters = this.drawTopThreeCharacters.bind(this);
	}
	
	componentWillMount() {
	}

	componentDidMount() {
		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}

		this.initProfileData();
	}

	initProfileData() {
		let tempUserId = 0;

		if (localStorage.getItem('userId') > 0) {
			tempUserId = localStorage.getItem('userId');
		} else if ( cookie.load('cookieId') ) {
			tempUserId = cookie.load('cookieId');
		} else {
			// this.setState({
			// 	redirect: "/"
			// })
			this.props.history.push('/');
		}

		this.setState({
			currentUserId: tempUserId
		}, function(){
			this.getCurrencyList();
		})
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						orgCurrencyList: response.data
					}, function(){
						this.getTargetCurrency();
						this.setUserName();
						this.getPostCountData();
						this.getGameList();
						this.getTopThreeCharacters();
						this.getAssetNetworth();
						this.getCharacterNetworth();
					});
				}
			})
	}

	getTargetCurrency() {
		var filteredOptions = [];

		if ( localStorage.getItem('countryId') ) {
			filteredOptions = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.countryId == localStorage.getItem('countryId')
			);

			if (filteredOptions.length == 0) {
				filteredOptions = this.state.orgCurrencyList.filter(
					(currency) =>
					currency.status == 2
				);
			}
		}

		if (filteredOptions.length) {
			this.setState({
				toCurrency: filteredOptions[0]
			})
		} else {
			this.setState({
				toCurrency: null
			})
		}
	}

	getAssetNetworth() {
		if ( this.state.currentUserId ) {
			axios.defaults.withCredentials = true;
			
			axios.get(window.$backend_url + '/getAssetNetworth?userId=' + this.state.currentUserId)
				.then(response => {
					if(response.status === 200){
						if (response.data[0].assetNetworth) {
							var symbol = '$';
							var price = parseFloat(response.data[0].assetNetworth);

							if (this.state.toCurrency) {
								symbol = this.state.toCurrency.symbol;
								price = parseFloat(price) * parseFloat(this.state.toCurrency.rate);
							}

							price = parseFloat(price.toFixed(2));

							this.setState({
								assetNetworth : symbol + price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
							})
						} else {
							this.setState({
								assetNetworth : '0'
							})
						}
					}
				})
		}
	}

	getCharacterNetworth() {
		if ( this.state.currentUserId ) {
			axios.defaults.withCredentials = true;
			
			axios.get(window.$backend_url + '/getCharacterListWithGameInfo?userId=' + this.state.currentUserId)
				.then(response => {
					if(response.status === 200){
						var characterNetworth = 0;

						for (var i=0; i<response.data.length; i++) {
							if (response.data[i].characterPrice) {
								characterNetworth += response.data[i].characterPrice;
							}
						}

						if ( characterNetworth ) {
							var symbol = '$';
							var price = parseFloat(characterNetworth);

							if (this.state.toCurrency) {
								symbol = this.state.toCurrency.symbol;
								price = parseFloat(price) * parseFloat(this.state.toCurrency.rate);
							}

							price = parseFloat(price.toFixed(2));

							this.setState({
								characterNetworth : symbol + price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
							})
						} else {
							this.setState({
								characterNetworth: '0'
							})
						}
					}
				})
		}
	}

	setUserName() {
		if ( this.state.currentUserId ) {
			const userdata = {
				userid: this.state.currentUserId
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/getUserInfo',userdata)
				.then(response => {
					if(response.status === 200){
						this.setState({
							username : response.data[0].first_name + " " + response.data[0].last_name,
							xchangeAmount: response.data[0].xchangeAmount
						})

						if (response.data[0].role > 1) {
							this.setState({
								maxCount: 3
							})

							var targetDate = new Date(response.data[0].expire_date);
							var currentDate = new Date();
							var Difference_In_Time = targetDate.getTime() - currentDate.getTime(); 
							var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
							
							this.setState({
								remaining_days: Difference_In_Days
							})
						}
					}
				})

			this.setUserAvatar();
		}
	}

	setUserAvatar() {
		const userdata = {
			userid: this.state.currentUserId
		}		

		axios.defaults.withCredentials = true;
		
		axios.post(window.$backend_url + '/getUserAvatar', userdata)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						userAvatar:  "url('" + response.data + "')"
					})
				} else {
					this.setState({
						userAvatar: "url('assets/images/profile-img.png')"
					})
				}

			})
			.catch(error => {
				this.setState({
					userAvatar: "url('assets/images/profile-img.png')"
				})
			})
	}

	getPostCountData() {
		axios.get(window.$backend_url + '/getTotalPosts?userId=' + this.state.currentUserId)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						totalPosts: response.data
					});
				}
			})

		axios.get(window.$backend_url + '/getTotalComments?userId=' + this.state.currentUserId)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						totalComments: response.data
					});
				}
			})

		axios.get(window.$backend_url + '/getTotalCharacters?userId=' + this.state.currentUserId)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						totalCharacters: response.data
					});
				}
			})

		axios.get(window.$backend_url + '/getTotalAssets?userId=' + this.state.currentUserId)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						totalAssets: response.data
					});
				}
			})
	}

	getTopThreeCharacters() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getTopLikeCharacterList?userId=' + this.state.currentUserId)
			.then(response => {
				if ( response.status === 200 ) {
					let tempList = [];
					for (var i=0; i<response.data.length; i++) {
						if (response.data[i].mainImageUrl) {
							tempList.push(response.data[i].mainImageUrl);
						} else {
							tempList.push('/assets/images/loading.gif');
						}
					}

					this.setState({
						topThreeCharacterList: response.data,
						topThreeCharacterImageList: tempList
					})

					this.drawTopThreeCharacters();

					for (i=0; i<response.data.length; i++) {
						if ( this.state.topThreeCharacterList[i].mainImageUrl ) {

						} else {
							const data = {
								userId: response.data[i].userId,
								gameId: response.data[i].gameId,
								characterId: response.data[i].id
							}

							let currentIndex = i;

							axios.post(window.$backend_url + '/getCharacterMainImage', data)
								.then(response => {
									if ( response.status === 200 ) {
										let temp = this.state.topThreeCharacterImageList;
										temp[currentIndex] = response.data;
										this.setState({
											topThreeCharacterImageList: temp
										})

										this.drawTopThreeCharacters();
									}
								})
								.catch(error => {
									let temp = this.state.topThreeCharacterImageList;
									temp[currentIndex] = 'assets/images/popular-game-main.jpg';
									this.setState({
										topThreeCharacterImageList: temp
									})

									this.drawTopThreeCharacters();
								})
						}
					}
				}
			})
	}

	drawTopThreeCharacters() {
		let slider;
					
		slider = this.state.topThreeCharacterList.map((character, index) => {
			let characterBackStyle = {
				backgroundImage:  "url('" + this.state.topThreeCharacterImageList[index] + "')"
			};

			let activeClassName = "featuredCharacter";
			if (index >= this.state.maxCount) {
				activeClassName = "featuredCharacter disable";
			}

			if (index === 1 && this.state.topThreeCharacterList.length === 3) {
				activeClassName += " inverse";
			}

			var symbol = '$';
			var price = 0;
			if (character.characterPrice) {
				price = character.characterPrice;
			}

			if (this.state.toCurrency) {
				symbol = this.state.toCurrency.symbol;
				price = parseFloat(price) * parseFloat(this.state.toCurrency.rate);
			}

			price = parseFloat(parseFloat(price).toFixed(2));

			return(
					<div key={index} className={activeClassName}>
						<div className="singleCharacter text-center">
							<div className="img_character" style={characterBackStyle} onClick={this.goCharacterDescription.bind(this)} rel={character.id}></div>
							<h5 className="characterName">{character.name}</h5>
							<p className="characterPrice text-green">{symbol}{price}</p>
						</div>
					</div>
				)
		});

		//remove comment

		this.setState({
			topThreeCharacters: slider
		});
	}

	getAllGameList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						gameList: response.data
					})
				}
			})
	}

	getGameList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getCharacterListWithGameInfo?userId=' + this.state.currentUserId)
			.then(response => {
				if ( response.status === 200 ) {
					let tempList = [];

					for (var i=0; i<response.data.length; i++) {
						if (response.data[i].mainImageUrl) {
							tempList.push(response.data[i].mainImageUrl);
						} else {
							tempList.push('/assets/images/loading.gif');
						}
					}

					this.setState({
						characterList: response.data,
						characterImageList: tempList
					});


					this.makeGameCharacterList();

					for (i=0; i<response.data.length; i++) {
						if ( this.state.characterList[i].mainImageUrl ) {

						} else {
							const data = {
								userId: response.data[i].userId,
								gameId: response.data[i].gameId,
								characterId: response.data[i].id
							}

							let currentIndex = i;

							axios.post(window.$backend_url + '/getCharacterMainImage', data)
								.then(response => {
									if ( response.status === 200 ) {
										let temp = this.state.characterImageList;
										temp[currentIndex] = response.data;
										this.setState({
											characterImageList: temp
										})

										this.makeGameCharacterList();
									}
								})
								.catch(error => {
									let temp = this.state.characterImageList;
									temp[currentIndex] = 'assets/images/popular-game-main.jpg';
									this.setState({
										characterImageList: temp
									})

									this.makeGameCharacterList();
								})
						}
					}

				}
			})
	}
	
	makeGameCharacterList() {
		var filteredOptions = [];
		if ( localStorage.getItem('countryId') ) {
			filteredOptions = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.countryId == localStorage.getItem('countryId')
			);

			if (filteredOptions.length == 0) {
				filteredOptions = this.state.orgCurrencyList.filter(
					(currency) =>
					currency.status == 2
				);
			}
		}

		var toCurrency;
		if (filteredOptions.length) {
			toCurrency = filteredOptions[0];
		}

		let slider = null;
		let tempGameId = 0;
		
		let character_active_length = 0;

		var loadGames = false;
		
		slider = this.state.characterList.map((character, index) => {
			if (tempGameId === 0 || tempGameId !== character.gameId) {
				tempGameId = character.gameId;

				if (this.state.startKeyword !== '' && character.game_name.toUpperCase().charAt(0) === this.state.startKeyword) {
					loadGames = true;
				}

				if ((this.state.startKeyword === '' && character.game_name.toLowerCase().includes(this.state.searchKeyword.toLowerCase())) || loadGames) {
					const items = [];
					let gameCharacterCount = 0;

					for (var i=index; i<this.state.characterList.length; i++) {
						if (tempGameId === this.state.characterList[i].gameId) {
							let characterBackStyle = {
								backgroundImage:  "url('" + this.state.characterImageList[i] + "')"
							};

							let activeStatus = "subCharacterItem";
							
							if (this.state.characterList[i].active) {
								activeStatus = "subCharacterItem active";
								character_active_length++;
							}

							if (cookie.load('cookieId') && gameCharacterCount > 2 && this.state.maxCount === 1) {
								activeStatus += " disable";
							}

							gameCharacterCount++

							let btn_check = null;
							if (cookie.load('cookieId') && (cookie.load('cookieId') === this.state.currentUserId)) {
								btn_check = <div className="btnGroup">
												<div className="left-wrap">
													<label className="btnCehckCharacterOut">
														<span className="checkmark" onClick={this.selectCharacter.bind(this)} rel={this.state.characterList[i].id}></span>
													</label>
												</div>
												<div className="right-wrap">
													<button className="btnCloseCharacter" onClick={this.closeCharacter.bind(this)} rel={this.state.characterList[i].id}></button>
												</div>
											</div>
							}

							var symbol = '$';
							var price = 0;
							if (this.state.characterList[i].characterPrice) {
								price = this.state.characterList[i].characterPrice;
							}

							if (this.state.toCurrency) {
								symbol = this.state.toCurrency.symbol;
								price = price * parseFloat(this.state.toCurrency.rate);
							}

							price = parseFloat(price.toFixed(2));

							items.push(
									<div key={this.state.characterList[i].id} className="col-4">
										<div className={activeStatus}>
											{ btn_check }
											<div className="imageContainer">
												<div className="img_character" style={characterBackStyle} onClick={this.goCharacterDescription.bind(this)} rel={this.state.characterList[i].id}></div>
											</div>
											<h4 className="characterName">{this.state.characterList[i].name}</h4>
											<p className="characterPrice text-green">{symbol}{price}</p>
										</div>
									</div>
								);
						} else {
							break;
						}
					}

					let addCharacterButton = null;
					
					if (cookie.load('cookieId') && ((this.state.maxCount === 1 && gameCharacterCount < 10) || (this.state.maxCount === 3 && gameCharacterCount < 100) )  && (cookie.load('cookieId') === this.state.currentUserId)) {
						addCharacterButton = <div className="col-4">
												<div className="btn_add_character_out">
													<div className="btn_add_character" onClick={this.addGameCharacter.bind(this)} rel={character.gameId}>+</div>
												</div>
											</div>
					
					}

					return(
							<div key={index}>
								<div className="subCharacters" alt={character.game_name}>
									<div className="item">
										<img className="slide-image" alt="" src={'/assets/images/games/' + character.game_image} rel={character.gameId} onClick={this.goAssetPage.bind(this)} />
									</div>
									<div className="subCharactersList">
										<div className="row">
											{items}
											{addCharacterButton}
										</div>
									</div>
								</div>
							</div>
						)
				} else {
					return (null);
				}
			} else {
				return (null);
			}
		});

		if (this.state.searchKeyword === '') {
			this.setState({
				characterActiveCount: character_active_length
			});
		}

		this.setState({
			gameSlides: slider
		});
	}

	goCharacterDescription(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('characterId', e.target.getAttribute('rel'));
			for (var i=0; i<this.state.characterList.length; i++) {
				if (this.state.characterList[i].id == e.target.getAttribute('rel')) {
					localStorage.setItem('characterImage', this.state.characterImageList[i]);
					break;
				}
			}

			// this.setState({ redirect: "/characterDescription" });
			this.props.history.push('/characterDescription');
		}
	}

	selectCharacter(e) {
		if (cookie.load('cookieId') && (cookie.load('cookieId') === this.state.currentUserId)) {
			if ($(e.target).parents(".subCharacterItem").hasClass("active") || (this.state.characterActiveCount < this.state.maxCount && !$(e.target).parents(".subCharacterItem").hasClass("active"))){
				let count = this.state.characterActiveCount;
				if ($(e.target).parents(".subCharacterItem").hasClass("active")) {
					count--;
				} else {
					count++;
				}

				this.setState({
					characterActiveCount: count,
					topThreeCharacters: null
				})

				$(e.target).parents(".subCharacterItem").toggleClass("active");

				const data = {
						userId: cookie.load('cookieId'),
						characterId : e.target.getAttribute('rel')
					}

				axios.defaults.withCredentials = true;
				
				axios.post(window.$backend_url + '/activeCharacter',data)
					.then(response => {
						if(response.status === 200){
							this.getTopThreeCharacters();
						}
					})
					.catch(error => {
					})
			}
		}
	}

	closeCharacter(e) {
		if (cookie.load('cookieId') && (cookie.load('cookieId') === this.state.currentUserId)) {
			let count = this.state.characterActiveCount;
			if ($(e.target).parents(".subCharacterItem").hasClass("active")) {
				count--;
			}

			this.setState({
				characterActiveCount: count,
				topThreeCharacters: null
			})

			$(e.target).parents(".subCharacterItem").parent().remove();

			const data = {
					userId: cookie.load('cookieId'),
					characterId : e.target.getAttribute('rel')
				}

			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/removeCharacter',data)
				.then(response => {
					if(response.status === 200){
						this.getTopThreeCharacters();
						this.getPostCountData()
					}
				})
				.catch(error => {
				})
		}
	}

	goAssetPage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('gameId', e.target.getAttribute('rel'));
			// this.setState({ redirect: "/assets" });
			this.props.history.push('/assets');
		}
	}

	searchGame(e) {
		this.setState({
			searchKeyword: '',
			startKeyword: e.target.value
		}, function(){
			this.makeGameCharacterList();
		})
	}

	initSearchKeyword = (e) => {
		this.setState({
			startKeyword: ''
		}, function () {
			this.makeGameCharacterList();
		});
	}

	searchKeywordChangeHandler = (e) => {
		this.setState({
			searchKeyword: e.target.value,
			startKeyword: ''
		}, function () {
			this.makeGameCharacterList();
		});
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		})
	}

	toggleBuySubscription() {
		this.setState({  
			showBuySubscription: !this.state.showBuySubscription
		});
	}

	toggleBuyXchange() {
		this.setState({  
			showBuyXchange: !this.state.showBuyXchange
		});
	}

	toggleGiftXchange() {
		this.setState({  
			showGiftXchange: !this.state.showGiftXchange  
		});
	}

	addGameCharacter(e) {
		this.setState({
			currentGameId: e.target.getAttribute('rel'),
			showAddCharacterPopup: true
		});	
	}

	toggleAddCharacterPopup(e) {
		this.setState({
			showAddCharacterPopup: !this.state.showAddCharacterPopup
		});	
	}

	toggleAddCharacterPopupWithUpdate() {
		this.setState({
			showAddCharacterPopup: !this.state.showAddCharacterPopup  
		});	
		
		this.getGameList();	
	}

	checkLogin() {
		this.setState({
			gameSlides: null
		});

		this.getTargetCurrency();

		if (cookie.load('cookieId')) {
			this.setState({
				isLogin: true
			}, function(){
				this.drawTopThreeCharacters();
				this.makeGameCharacterList();
				this.getAssetNetworth();
				this.getCharacterNetworth();
			})
		} else {
			this.setState({
				isLogin: false
			}, function(){
				this.drawTopThreeCharacters();
				this.makeGameCharacterList();
			})
		}
	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		const personStyle = {
			backgroundImage: this.state.userAvatar || ""
		};

		const sliderOption = {
				loop: false,
				margin: 10,
				nav:true,
				responsive:{
					0: {
						items: 1,
					},
					600: {
						items: 2,
					},
					1000: {
						items: 3,
					},
				}
			};
		
		return(
			<div className="digit profilePage">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="2" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />

							{ this.state.currentUserId ?
								<div className="featuredCharacters">
									<div className="featured_title">{this.state.dataLanguage['featured_characters']}</div>									
									{ this.state.topThreeCharacters ?
										<div className="featuredCharacterOut">
											{this.state.topThreeCharacters}
										</div>
									: null}
									
								</div>
							: null }

							{ this.state.currentUserId ?
								<div className="person_info">
									<div className="row">
										<div className="col-md-3">
											<div className="back-avatar" style={personStyle}>
												<p className="user-name text-right">{this.state.username}</p>
											</div>
										</div>
										<div className="col-md-4 person_info_text_1">
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_posts']}:</span> <span className="text-counts">{this.state.totalPosts}</span></p></div>
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_comments']}:</span> <span className="text-counts">{this.state.totalComments}</span></p></div>
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_characters']}:</span> <span className="text-counts">{this.state.totalCharacters}</span></p></div>
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_assets']}:</span> <span className="text-counts">{this.state.totalAssets}</span></p></div>
										</div>
										{ this.state.isLogin ?
											<div className="col-md-5 person_info_text_2">
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['xchange_currency']}:</span> <span className="text-green">{this.state.xchangeAmount}</span></p></div>
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['subscription_days_remaining']}:</span> <span className="text-green">{this.state.remaining_days} {this.state.remaining_days > 1 ? this.state.dataLanguage['days'] : this.state.dataLanguage['day']}</span></p></div>
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_asset_networth']}:</span> <span className="text-green">{this.state.assetNetworth}</span></p></div>
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_character_networth']}:</span> <span className="text-green">{this.state.characterNetworth}</span></p></div>
											</div>
										: null }
									</div>
								</div>
							: null }
							
						</div>
					</section>
					
					<div className="main-area">
						{ this.state.currentUserId ?
							<div className="container">
								<div className="search-container-out">
									<div className="search-container game-search">
										<div className="form">
											<input name="search" placeholder={this.state.dataLanguage['search_games']} type="text" value={this.state.searchKeyword} onChange={this.searchKeywordChangeHandler} />
											<button onClick={this.initSearchKeyword}><img alt="" src="/assets/images/search-icon.png" /></button>
										</div>
									</div>
									<div className="alpahbet-buttons text-center">
										<button onClick={this.searchGame.bind(this)} value="">{this.state.dataLanguage['all']}</button>
										<button onClick={this.searchGame.bind(this)} value="A">A</button>
										<button onClick={this.searchGame.bind(this)} value="B">B</button>
										<button onClick={this.searchGame.bind(this)} value="C">C</button>
										<button onClick={this.searchGame.bind(this)} value="D">D</button>
										<button onClick={this.searchGame.bind(this)} value="E">E</button>
										<button onClick={this.searchGame.bind(this)} value="F">F</button>
										<button onClick={this.searchGame.bind(this)} value="G">G</button>
										<button onClick={this.searchGame.bind(this)} value="H">H</button>
										<button onClick={this.searchGame.bind(this)} value="I">I</button>
										<button onClick={this.searchGame.bind(this)} value="J">J</button>
										<button onClick={this.searchGame.bind(this)} value="K">K</button>
										<button onClick={this.searchGame.bind(this)} value="L">L</button>
										<button onClick={this.searchGame.bind(this)} value="M">M</button>
										<button onClick={this.searchGame.bind(this)} value="N">N</button>
										<button onClick={this.searchGame.bind(this)} value="O">O</button>
										<button onClick={this.searchGame.bind(this)} value="P">P</button>
										<button onClick={this.searchGame.bind(this)} value="Q">Q</button>
										<button onClick={this.searchGame.bind(this)} value="R">R</button>
										<button onClick={this.searchGame.bind(this)} value="S">S</button>
										<button onClick={this.searchGame.bind(this)} value="T">T</button>
										<button onClick={this.searchGame.bind(this)} value="U">U</button>
										<button onClick={this.searchGame.bind(this)} value="V">V</button>
										<button onClick={this.searchGame.bind(this)} value="W">W</button>
										<button onClick={this.searchGame.bind(this)} value="X">X</button>
										<button onClick={this.searchGame.bind(this)} value="Y">Y</button>
										<button onClick={this.searchGame.bind(this)} value="Z">Z</button>
									</div>
								</div>
								<div className="profileAssetList">
									<div className="game-slider">
										{this.state.gameSlides ?
											<div className="owl-slider">
												<OwlCarousel className="owl-theme" {...sliderOption} >
													{this.state.gameSlides}
												</OwlCarousel>
											</div>
										: null }
									</div>
								</div>
							</div>
						: null }
					</div>
				</div>
				{this.state.showBuySubscription ?  
					<Modal show={this.state.showBuySubscription} onHide={this.toggleBuySubscription.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Buysubscription dataLanguage={this.state.dataLanguage} />
					</Modal>
				: null  
				}
				{this.state.showBuyXchange ?  
					<Modal show={this.state.showBuyXchange} onHide={this.toggleBuyXchange.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Buyxchange dataLanguage={this.state.dataLanguage} />
					</Modal>
				: null  
				}{this.state.showGiftXchange ?
					<Modal show={this.state.showGiftXchange} onHide={this.toggleGiftXchange.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Giftxchange dataLanguage={this.state.dataLanguage} />
					</Modal>
				: null  
				}
				{this.state.showAddCharacterPopup ?  
					<Modal show={this.state.showAddCharacterPopup} onHide={this.toggleAddCharacterPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AddCharacter dataLanguage={this.state.dataLanguage} currentGameId={this.state.currentGameId} closeAddCharacterPopup={this.toggleAddCharacterPopupWithUpdate.bind(this)} gameList={this.state.gameList} />
					</Modal>
				: null  
				}
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
			</div>
		)
	}
}

export default Profile;


// WEBPACK FOOTER //
// ./src/components/Profile.js